<template>
  <div>
    <app-notification :title="'יש בעיה עם פרטי החשבונות.'"
                      :text="'אי אפשר לעדכן את התזרים כי חלק מפרטי החשבונות שאצלינו לא עובדים.'"
                      :notification-buttons="[
                        {
                          title:'לעדכון פרטים',
                          variant: 'primary',
                          action: goToCredentialsSettings,
                        },
                      ]"
                      :icon-type="'danger'"/>
  </div>
</template>

<script>
import Segment from '../../../../../../../Segment';
import AppNotification from '../AppNotification.vue';
import router from '../../../../../../../router';

export default {
  name: 'UpdateCredentialsNotification',
  components: {
    AppNotification,
  },
  async created() {
    Segment.trackUserGot('UpdateCredentialsNotificationShown');
  },
  methods: {
    goToCredentialsSettings() {
      Segment.trackUserInteraction('goToCredentialsSettingsClicked');
      router.push({ path: '/credentials' });
    },
  },
};

</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/notification/notification-types/UpdateCredentialsNotification.vue